const React = require('react');


module.exports = (props) => {
  return (
    <div
      {...props}
      className={`ph10 ws tov rlv
        (abs|sr|st50%|xY-50%|h20|w2|bg505255|cnt_|dB):not[:last]:after `
        + (props.className || '')}
    />
  );
};
